'use strict';

import ViewTransformer from './transform/ViewTransformer';

export default ViewTransformer;


// WEBPACK FOOTER //
// ./node_modules/react-native-view-transformer/library/index.js